import React, { useState } from 'react';

import { IconButton, InputAdornment, TextField } from '@mui/material';

import { Eye, EyeOff } from 'lucide-react';

import PropTypes from 'prop-types';

import { COLORS } from '../Constant/COLORS';

const PasswordField = ({ InputProps, ...props }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleClick = () => {
    setIsPasswordVisible(currentState => !currentState);
  };

  return (
    <TextField
      type={isPasswordVisible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton onClick={handleClick}>
              {isPasswordVisible ? (
                <EyeOff size={19} color={COLORS.inkSoft} strokeWidth={1.8} />
              ) : (
                <Eye size={19} color={COLORS.inkSoft} strokeWidth={1.8} />
              )}
            </IconButton>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...props}
    />
  );
};

PasswordField.propTypes = { InputProps: PropTypes.object };

export default PasswordField;
